import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useFechamentoDaCompetencia } from '../../../api/queries/chamados'
import { AvisoDeErro, Carregando, EstadoVazio } from '../../../components/Estados'
import { TEXTOS } from '../../../lib/glossario'
import { dataHora } from '../../../lib/datas'
import { competenciaPorExtenso } from '../../chamados/competencia'
import { ControlesDoTrp } from './ControlesDoTrp'
import { DocumentoTrp } from './DocumentoTrp'
import './trp.css'

/**
 * O Termo de Recebimento Provisório de uma competência, pronto para imprimir.
 *
 * Vive FORA do `Layout` (ver `routes/router.tsx`): menu, cabeçalho e rodapé da aplicação não podem
 * sair no papel. Continua dentro do portão de contratante — a fiscalização é da equipe da
 * Prefeitura, e quem é medido não emite o próprio termo de recebimento.
 *
 * **Só de competência FECHADA.** Não é regra de tela: em competência fechada o servidor devolve a
 * apuração congelada, e duas chamadas seguidas dão o mesmo JSON. Emitir sobre a prévia produziria
 * um termo cujo número muda entre a impressão e a assinatura — que é exatamente o defeito que o
 * fechamento existe para matar.
 *
 * @returns a página do termo
 */
export function PaginaTrp() {
  const { competencia = '' } = useParams()
  const { data: apuracao, isPending, isError, error } = useFechamentoDaCompetencia(competencia)

  // Fixado na montagem: a data da emissão sai nas duas folhas, e um `new Date()` dentro do JSX
  // faria as duas discordarem quando o React reconciliasse a árvore durante a impressão.
  const emitidoEm = useMemo(() => dataHora(new Date().toISOString()), [])

  const fechada = apuracao?.competencia.situacao === 'FECHADA'

  return (
    <div className="min-h-screen bg-slate-200 print:bg-white">
      <ControlesDoTrp competencia={competencia} pronto={Boolean(apuracao) && fechada} />

      <main className="px-4 py-6 print:p-0">
        {isPending && <Carregando texto="Montando o termo…" />}
        {isError && (
          <div className="mx-auto max-w-2xl">
            <AvisoDeErro erro={error} titulo="Não foi possível montar o termo" />
          </div>
        )}
        {apuracao && !fechada && (
          <div className="mx-auto max-w-2xl">
            <EstadoVazio
              titulo={TEXTOS.trp.soFechada.titulo}
              ajuda={TEXTOS.trp.soFechada.ajuda(competenciaPorExtenso(competencia))}
            />
          </div>
        )}
        {apuracao && fechada && <DocumentoTrp apuracao={apuracao} emitidoEm={emitidoEm} />}
      </main>
    </div>
  )
}
